import stock from '@/api/stock/stock-in-v2'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'
import { split } from 'lodash'

export const state = {
  ...baseState,
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
  vendor_id: [],
  location_id: [],
  formViewDatas: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_VENDOR_ID(state, data) {
    state.vendor_id = data
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_VIEW_MODELS(state, { data, index }) {
    if (!index) {
      state.formViewDatas = data;
    } else {
      split(index, ",").forEach(el => {
        state.formViewDatas[el] = data[el];
      });
    }
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          location_id: context.state.location_id,
          vendor_id: context.state.vendor_id,
          date_between: _.join(context.state.dateRange, ','),
        }
      },
      attrubutes
    )
    return stock.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return stock.store(data)
  },
  update(context, { id, data }) {
    return stock.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stock.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return stock.destroy(id)
  },
  toPdf(context, id) {
    return stock.toPdf(id)
  },
  async getFormViewModel(context, { params, index }) {
    let response = await stock.formViewModel({ params: params });
    context.commit("SET_VIEW_MODELS", {
      data: response.data,
      index: index
    });
    return Promise.resolve(response);
  },
}
